/* eslint-disable */
// This file is automatically generated and should not be edited directly.
// Please edit the corresponding SVG file

import React from 'react';

const HamburgerHover = (props: any) => (
<svg {...props} xmlns="http://www.w3.org/2000/svg"   viewBox="0 0 32 32" fill="none">
  <rect x="9" y="7" width="20" height="2" rx="1" fill="#282828"/>
  <rect x="3" y="15" width="26" height="2" rx="1" fill="#282828"/>
  <rect x="3" y="23" width="20" height="2" rx="1" fill="#282828"/>
</svg>
);

export default HamburgerHover;